import React, { useState, useEffect, useRef } from "react";
import { Card, Nav, Row, Tab } from "react-bootstrap";

import { SvgComponent } from "components";
import ConfigurarCompania from "views/ConfigurarCompania";
import UsuariosEquipos from "views/UsuariosEquipos";
import { Simplebar } from "components";
import { useAuthentication, useMiCuentaPage, useTheme } from "hooks";
import { Permisos } from "utils/permisos";
import "../Entidades/EntidadesList.scss";
import useMessage from "hooks/useMessage";
import { LeftSection, LeftSectionHeader } from "components";
import LeftSectionBody from "components/MiCuenta/LeftSection/LeftSectionBody/LeftSectionBody";
import { SeguridadManager } from "managers";
import { StringHelper } from "utils";
import { FacturasSection } from "components";
import { hide } from "@popperjs/core";
import useExceptionHandler from "hooks/useExceptionHandler";
import { ConfiguracionCuenta } from "components/MiCuenta/ConfiguracionSection/ConfiguracionSection";
import { useMiCuenta } from 'hooks/useMiCuenta';
import { PLANES_ECF } from 'utils'

const MiCuenta = ({ setShowCanvas, showCanvas }) => {
    const PANTALLA_BALANCE = "balance";
    const PANTALLA_CONFIGURACIONES = "configuraciones";
    let Entidad = PANTALLA_BALANCE;
    let Opcion = "";
    const { theme } = useTheme();
    const { usuario } = useAuthentication();
    const [currentTab, setCurrentTab] = useState("");
    const { tienePermiso } = useAuthentication();
    const ref = useRef(null);
    const iconColor = "#3f3f3f";
    const iconStyle = { marginRight: "15px" };
    const { Message, cerrarAlertas } = useMessage();
    const { handleException } = useExceptionHandler();
    const {
        setMiCuentaState,
        setMiCuentaLocation,
        getMiCuentaLocation,
    } = useMiCuentaPage();

    const { montoPendiente } = useMiCuenta();

    const [compania, setCompania] = useState({
        IncluirITBISDetalles: false,
        MostrarValorPagar: false,
        IncluirSubTotalesInformativos: false,
        UsaAlertarFinSerie: false,
    });

    const navLinkStyle = {
        width: "100%"
    };

    const cargarCompania = async () => {
        try {
            showLoading();
            const data = await SeguridadManager.buscarCompania();

            if (data) {
                const companiaData = {
                    ...data,
                    Color1: data.Color1 ? "#" + data.Color1 : undefined,
                    Color2: data.Color2 ? "#" + data.Color2 : undefined,
                    Color3: data.Color3 ? "#" + data.Color3 : undefined,
                };
                setCompania(companiaData);
            }
        } catch (error) {
            handleException(error);
        } finally {
            hideLoading();
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            try {
                const { location, option } = getMiCuentaLocation();
                if (location && Entidad && Entidad !== location) {
                    Entidad = location;
                    setCurrentTab(location);
                }
                if (Opcion !== "" && option !== Opcion) {
                    Opcion = option;
                }
            } catch { }
        }, 200);

        return () => {
            clearInterval(interval);
        };
    }, []);

    useEffect(() => {
        if (showCanvas) {
            showLoading();
            cargarCompania();
        }
        return () => {
            cerrarAlertas();
            hideLoading();
        };
    }, [showCanvas]);

    useEffect(() => {
        if (Entidad) {
            setCurrentTab(Entidad);
        } else setCurrentTab(PANTALLA_BALANCE);
    }, [Entidad]);

    const handleSelect = (eventKey) => {
        setMiCuentaLocation(eventKey);
    };

    const hideLoading = () => {
        ref?.current?.showLoading(false);
    };
    const showLoading = () => {
        ref?.current?.showLoading(true);
    };

    const Config = {
        LeftSectionHeader: {
            label: 'Mi Cuenta',
            onClick: () => {
                setMiCuentaState(false);
                setShowCanvas(false);
                Entidad = PANTALLA_BALANCE;
                setMiCuentaLocation(PANTALLA_BALANCE);
                hideLoading();
            }
        },
        LeftSectionBody: {
            showImage: true,
            img64: usuario?.LogoBase64,
            icon: "id-card",
            title: compania?.Nombre,
            HEIGHT: "91vh",
            subTitleRenderer: () => {
                return (
                    <>
                        {compania?.RNC ? <p className="p-0 m-0">{compania?.RNC}</p> : ""}
                        {compania?.Codigo ? <p className="p-0 m-0">{compania?.Codigo}</p> : ""}
                        {compania?.TelefonoPrincipal ? (
                            <p className="p-0 m-0">
                                {StringHelper.formatPhoneNumber(compania?.TelefonoPrincipal)}{" "}
                                {compania?.Extension1 && (
                                    <>
                                        <strong>Ext.</strong>
                                        {compania?.Extension1}
                                    </>
                                )}
                            </p>
                        ) : (
                            ""
                        )}
                        {compania?.TelefonoSecundario ? (
                            <p className="p-0 m-0">
                                {StringHelper.formatPhoneNumber(compania?.TelefonoSecundario)}{" "}
                                {compania?.Extension2 && (
                                    <>
                                        <strong>Ext.</strong>
                                        {compania?.Extension2}
                                    </>
                                )}
                            </p>
                        ) : (
                            ""
                        )}
                        {compania?.Email ? (
                            <p className="p-0 m-0">
                                {compania?.Email.split(",")[0]}
                            </p>
                        ) : (
                            ""
                        )}
                    </>
                );
            },
            sections: [
                {
                    title: "Facturación de Servicio",
                    details: [
                        { titulo: 'RNC', informacion: compania?.RNC },
                        { titulo: 'Nombre', informacion: compania?.Nombre },
                        { titulo: 'Teléfono Principal', informacion: compania?.TelefonoPrincipal },
                        { titulo: 'Email', informacion: compania?.Email },
                    ],
                },
                {
                    title: "Estado de Cuenta",
                    details: [
                        { titulo: "Balance Pendiente", informacion: montoPendiente, descripcion: false },
                    ],
                },
                {
                    title: "Configuracion",
                    details: [
                        { titulo: "Plan", informacion: PLANES_ECF?.find((plan) => plan.value === compania.CantidadTransacciones)?.name ?? PLANES_ECF?.[0].name }
                    ]
                }
            ],
        },
    }

    return (

        <Simplebar
            ref={ref}
            size="xxxl"
            backdrop={true}
            placement={"end"}
            portal={false}
            visible={showCanvas}
            setShow={(e) => {
                setMiCuentaState(e);
            }}
            useLoading={true}
            title="Mi Cuenta"
            btnLeft={{
                show: false,
                label: "Grabar",
                func: () => { },
            }}
            btnRight={{
                show: false,
                label: "Grabar",
                func: () => { },
            }}
            hideHeader={false}
        >
            <Row
                style={{
                    minHeight: "78vh",
                    maxHeight: "78vh",
                    padding: "0px 0px 0px 15px",
                    marginRight: 0,
                    marginTop: "0px",
                    width: "96vw",
                }}
            >

                <div
                    style={{
                        width: "25%",
                        minHeight:
                            Config.ViewConfig && Config.ViewConfig.simplebar
                                ? `85vh`
                                : `calc(100vh - ${theme.MAX_HEIGHT_HEADER})`,
                        padding: 0
                    }}
                >
                    <>
                        <LeftSection
                            simplebar={Config.ViewConfig && Config.ViewConfig.simplebar}
                            height={Config.LeftSectionBody.HEIGHT}
                        >
                            <LeftSectionHeader {...Config.LeftSectionHeader} />
                            <LeftSectionBody {...Config.LeftSectionBody} />
                        </LeftSection>
                    </>
                </div>


                <Card style={{ width: "75%" }}>
                    <Card.Body className="p-0 m-0">
                        <Nav
                            variant="tabs"
                            defaultActiveKey={PANTALLA_BALANCE}
                            activeKey={currentTab}
                            className="flex-row"
                            onSelect={handleSelect}
                            style={{
                                borderBottom: 0,
                            }}
                        >
                            <Nav.Item>
                                <Nav.Link eventKey={PANTALLA_BALANCE} style={navLinkStyle}>
                                    <SvgComponent
                                        fill={iconColor}
                                        style={iconStyle}
                                        iconName="balance"
                                    />
                                    Mis Facturas y Balance Pendiente
                                </Nav.Link>
                            </Nav.Item>

                            {tienePermiso(Permisos.Usuario.LISTAR) && (
                                <Nav.Item>
                                    <Nav.Link eventKey={PANTALLA_CONFIGURACIONES} style={navLinkStyle}>
                                        <SvgComponent
                                            fill={iconColor}
                                            iconName="manufacturing"
                                            style={iconStyle}
                                        />
                                        Mis Configuraciones
                                    </Nav.Link>
                                </Nav.Item>
                            )}
                        </Nav>

                        <Tab.Container
                            id="icons-tabs"
                            defaultActiveKey={PANTALLA_BALANCE}
                            activeKey={currentTab}
                        >
                            <Tab.Content>
                                <Tab.Pane eventKey={PANTALLA_BALANCE} className="p-0 m-0">
                                    <FacturasSection
                                        hideLoading={hideLoading}
                                        showLoading={showLoading}
                                        isActive={currentTab === PANTALLA_BALANCE}
                                    />
                                </Tab.Pane>

                                {tienePermiso(Permisos.Usuario.LISTAR) && (
                                    <Tab.Pane eventKey={PANTALLA_CONFIGURACIONES} className="p-0 m-0">
                                        <ConfiguracionCuenta
                                            hideLoading={hideLoading}
                                            showLoading={showLoading}
                                            isActive={currentTab === PANTALLA_CONFIGURACIONES}
                                            option={Opcion}
                                        />
                                    </Tab.Pane>
                                )}
                            </Tab.Content>
                        </Tab.Container>
                    </Card.Body>
                </Card>
            </Row>
        </Simplebar>

    );
};

export default MiCuenta;
